import { render, staticRenderFns } from "./sp-table.vue?vue&type=template&id=1b064e7c&scoped=true"
import script from "./sp-table.vue?vue&type=script&lang=js"
export * from "./sp-table.vue?vue&type=script&lang=js"
import style0 from "./sp-table.vue?vue&type=style&index=0&id=1b064e7c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b064e7c",
  null
  
)

export default component.exports